export const mapOptions = (catalogArray, valueKey = 'value', labelKey = 'label') => {
  return Array.isArray(catalogArray) 
    ? catalogArray.map(item => ({
        value: item[valueKey],
        label: item[labelKey]
      }))
    : [];
};